module.exports = __webpack_public_path__ + "assets/c212cf56d96549a8a103c75827b2467a.png";